(()=>{
  const section=document.getElementById('nr-builder-next-chapter');
  const builder=document.getElementById('tnr-3d-builder');
  const configNode=document.getElementById('nr-chapter-products');
  if(!section||!builder||!configNode)return;
  let config;
  try{config=JSON.parse(configNode.textContent)}catch{return}
  const $=selector=>section.querySelector(selector);
  const nav=$('[data-chapter-nav]');
  const productImage=$('[data-chapter-product-image]');
  const thumbs=$('[data-chapter-thumbs]');
  const action=$('[data-chapter-action]');
  const roomSelect=builder.querySelector('#room');
  const roomChoices=[...section.querySelectorAll('[data-chapter-room-choice]')].filter(button=>button.dataset.src);
  const roomVideo=$('[data-chapter-room-video]');
  const roomScreen=$('[data-chapter-room-screen]');
  const roomPlay=$('[data-chapter-room-play]');
  let selection=builder.tnrSelection||null;
  let activeKey='net';
  let slide=0;
  let imageVersion=0;
  let pendingKey='';
  let roomActive=null;
  let roomVisible=false;
  let roomManual=false;
  let roomPaused=false;
  let roomVersion=0;
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:config.currency||window.Shopify?.currency?.active||'USD',maximumFractionDigits:Number(cents)%100?2:0}).format(Number(cents)/100);
  const names={'pro-turf':'Pro Turf','cce-mat':'Country Club Elite','platinum-turf':'Platinum Turf','side-barriers':'Side barriers','no-fly-zone':'No Fly Zone','nfz-kit':'No Fly Zone Kit','simulator-kit':'Simulator kit','impact-screen':'Impact screen',pads:'Frame pads',cover:'Outdoor cover'};
  const turfKeys=['pro-turf','cce-mat','platinum-turf'];
  const extraKeys=['side-barriers','no-fly-zone','nfz-kit','simulator-kit','impact-screen','pads','cover'];
  const conflicts={'side-barriers':['nfz-kit'],'no-fly-zone':['nfz-kit','simulator-kit'],'nfz-kit':['no-fly-zone','side-barriers','simulator-kit'],'simulator-kit':['impact-screen','nfz-kit','no-fly-zone'],'impact-screen':['simulator-kit']};
  const netName=()=>({home:'Home',pro:'Pro',mini:'Mini',junior:'Junior','pro-8':'Pro 8','pro-9':'Pro 9','pro-10':'Pro 10','pro-xl':'Pro XL'})[selection?.net]||'Pro';
  function entries(){
    const net=config.nets[selection?.net]||config.nets.pro;
    return [{key:'net',group:'',name:`${netName()} net`,product:net},
      ...turfKeys.map(key=>({key,group:'Turf',name:names[key],product:config.turf[key]})),
      ...extraKeys.map(key=>({key,group:'Add-ons',name:names[key],product:config.extras[key]}))];
  }
  function selected(key){
    if(key==='net')return true;
    if(turfKeys.includes(key))return selection?.turf===key;
    if(key==='pads'||key==='cover')return Boolean(selection?.[key]);
    return Boolean(selection?.selected?.includes(key));
  }
  function builderInput(key){
    if(turfKeys.includes(key))return builder.querySelector(`[name="turf"][value="${key}"]`);
    if(key==='pads'||key==='cover')return builder.querySelector(`#${key}`);
    return builder.querySelector(`[data-part="${key}"]`);
  }
  function variantFor(key,product){
    const variants=product?.variants||[];
    if(key==='net'||turfKeys.includes(key))return variants[0]||null;
    const net=selection?.net;
    if(!net)return null;
    let variantTitle=netName();
    if(key==='side-barriers')variantTitle=net==='mini'?'Mini':net==='junior'?'Junior':net==='pro-xl'?'Pro XL':['pro-8','pro-9','pro-10'].includes(net)?'Pro 8 - Pro 9 - Pro 10':'Universal - Pro, Home & Large';
    if(key==='pads')variantTitle=netName()+' / Pair';
    return variants.find(variant=>variant.title.trim().toLowerCase()===variantTitle.toLowerCase())||null;
  }
  function activeEntry(){return entries().find(item=>item.key===activeKey)||entries()[0]}
  function renderNav(){
    const items=entries();
    nav.replaceChildren();
    let group='';
    for(const item of items){
      if(item.group&&item.group!==group){group=item.group;const heading=document.createElement('div');heading.className='nr-product-browser__group';heading.textContent=group;nav.append(heading)}
      const button=document.createElement('button');button.type='button';button.role='tab';button.dataset.chapterTab=item.key;
      button.id=`nr-chapter-tab-${item.key}`;button.setAttribute('aria-controls','nr-chapter-product-panel');
      button.setAttribute('aria-selected',String(item.key===activeKey));button.tabIndex=item.key===activeKey?0:-1;
      const image=document.createElement('img');image.src=item.product?.images?.[0]?.thumb||'';image.alt='';image.loading='lazy';
      const label=document.createElement('span');label.textContent=item.name;
      const check=document.createElement('span');check.className='nr-product-browser__check';check.textContent='✓';check.setAttribute('aria-label',selected(item.key)?'In your setup':'');check.hidden=!selected(item.key);
      button.append(image,label,check);nav.append(button);
    }
  }
  function renderSlide(item){
    const images=item.product?.images||[];
    slide=(slide+images.length)%Math.max(images.length,1);
    const media=images[slide];
    $('[data-chapter-media-prev]').disabled=images.length<2;
    $('[data-chapter-media-next]').disabled=images.length<2;
    thumbs.replaceChildren(...images.map((view,index)=>{
      const button=document.createElement('button');button.type='button';button.dataset.chapterThumb=String(index);
      button.setAttribute('aria-label',`View ${item.name} image ${index+1} of ${images.length}`);
      button.setAttribute('aria-pressed',String(index===slide));
      const image=document.createElement('img');image.src=view.thumb||view.src;image.alt='';image.loading='lazy';button.append(image);return button;
    }));
    const version=++imageVersion;
    if(!media?.src){productImage.hidden=true;return}
    if(productImage.getAttribute('src')===media.src){productImage.alt=media.alt||item.name;productImage.hidden=false;productImage.classList.remove('is-changing');return}
    productImage.classList.add('is-changing');
    const next=new Image();
    next.onload=()=>{if(version!==imageVersion)return;productImage.src=media.src;productImage.alt=media.alt||item.name;productImage.hidden=false;productImage.classList.remove('is-changing')};
    next.onerror=()=>{if(version===imageVersion){productImage.hidden=true;productImage.classList.remove('is-changing')}};
    next.src=media.src;
  }
  function renderProduct(resetSlide=false){
    const item=activeEntry();
    $('.nr-product-browser__stage').setAttribute('aria-labelledby',`nr-chapter-tab-${item.key}`);
    if(resetSlide)slide=0;
    $('[data-chapter-product-title]').textContent=item.name;
    $('[data-chapter-product-copy]').textContent=config.copy[item.key]||config.copy.net;
    const variant=variantFor(item.key,item.product);
    $('[data-chapter-price]').textContent=variant?money(variant.price):'';
    const link=$('[data-chapter-product-link]');
    link.href=item.product?.handle?(location.hostname==='127.0.0.1'||location.hostname==='localhost'?'https://www.thenetreturn.com':'')+'/products/'+encodeURIComponent(item.product.handle):'#';
    const input=builderInput(item.key);
    const ready=Boolean(selection?.net);
    const overlaps=(conflicts[item.key]||[]).some(key=>selected(key));
    const compatible=item.key==='net'||(ready&&variant?.available===true&&input&&!input.disabled&&!overlaps);
    const status=$('[data-chapter-availability]');
    status.textContent=item.key==='net'?'':!ready?'Choose a net above to see available options.':!variant?'Not offered for the net you chose.':!variant.available?'Currently unavailable.':overlaps?'This overlaps with something already in your setup.':input?.disabled?'Not available for the net you chose.':'';
    action.disabled=Boolean(pendingKey)||!compatible;
    action.dataset.chapterAction=item.key;
    action.textContent=pendingKey===item.key?'Updating your setup…':item.key==='net'?'Change net':selected(item.key)?'Remove from setup':'Add to setup';
    renderSlide(item);
  }
  function render(resetSlide=false){renderNav();renderProduct(resetSlide)}
  function openNet(){builder.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'start'});builder.querySelector('[data-edit="net"]')?.click()}
  function changeSetup(key){
    if(key==='net'){openNet();return}
    if(pendingKey)return;
    const input=builderInput(key);
    if(!input||input.disabled)return;
    pendingKey=key;renderProduct();
    if(turfKeys.includes(key)){
      const target=selected(key)?builder.querySelector('[name="turf"][value=""]'):input;
      if(!target){pendingKey='';renderProduct();return}
      target.checked=true;target.dispatchEvent(new Event('change',{bubbles:false}));
    }else{
      input.checked=!selected(key);input.dispatchEvent(new Event('change',{bubbles:false}));
    }
    const attempted=key;
    setTimeout(()=>{if(pendingKey!==attempted)return;pendingKey='';renderProduct();$('[data-chapter-availability]').textContent='That change did not finish. Try it in the builder above.'},12000);
  }
  nav.addEventListener('click',event=>{const button=event.target.closest('[data-chapter-tab]');if(!button)return;activeKey=button.dataset.chapterTab;render(true)});
  nav.addEventListener('keydown',event=>{
    if(!['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(event.key))return;
    event.preventDefault();
    const buttons=[...nav.querySelectorAll('[data-chapter-tab]')];const index=buttons.findIndex(button=>button.dataset.chapterTab===activeKey);
    const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowLeft'||event.key==='ArrowUp'?-1:1)+buttons.length)%buttons.length;
    buttons[next].click();nav.querySelector(`[data-chapter-tab="${activeKey}"]`)?.focus();
  });
  section.addEventListener('click',event=>{
    const thumb=event.target.closest('[data-chapter-thumb]');if(thumb){slide=Number(thumb.dataset.chapterThumb);renderSlide(activeEntry());return}
    if(event.target.closest('[data-chapter-media-prev]')){slide--;renderSlide(activeEntry());return}
    if(event.target.closest('[data-chapter-media-next]')){slide++;renderSlide(activeEntry());return}
    if(event.target.closest('[data-chapter-action]'))changeSetup(activeKey);
  });
  builder.addEventListener('tnr:selection',event=>{
    const previous=selection?.net;
    selection=event.detail;
    pendingKey='';
    render(previous!==selection.net&&activeKey==='net');
    if(!roomManual&&roomSelect?.value&&roomActive?.dataset.room!==roomSelect.value){
      showRoom(roomChoices.find(button=>button.dataset.room===roomSelect.value)||roomChoices[0]);
    }
  });

  function updateRoomPlay(){roomPlay.textContent=roomVideo.paused?'▶':'Ⅱ';roomPlay.setAttribute('aria-label',roomVideo.paused?'Play video':'Pause video')}
  function playRoom(){if(document.hidden||!roomVisible||roomPaused||reduced()||!roomActive?.dataset.src)return;roomVideo.play().then(updateRoomPlay).catch(updateRoomPlay)}
  function showRoom(button,manual=false){
    if(!button)return;
    if(manual)roomManual=true;
    roomActive=button;
    roomChoices.forEach(choice=>{choice.setAttribute('aria-selected',String(choice===button));choice.style.setProperty('--room-progress','0%');choice.tabIndex=choice===button?0:-1});
    $('[data-chapter-room-title]').textContent=button.dataset.title||button.textContent;
    $('[data-chapter-room-copy]').textContent=button.dataset.copy||'';
    const version=++roomVersion;
    roomScreen.classList.add('is-changing');
    roomVideo.pause();
    setTimeout(()=>{
      if(version!==roomVersion)return;
      roomVideo.poster=button.dataset.poster||'';
      roomVideo.src=button.dataset.src;
      roomVideo.load();
      roomScreen.classList.remove('is-changing');
      updateRoomPlay();playRoom();
    },reduced()?0:180);
  }
  roomChoices.forEach(button=>button.addEventListener('click',()=>showRoom(button,true)));
  section.querySelector('.nr-rooms__choices')?.addEventListener('keydown',event=>{
    if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
    event.preventDefault();const index=roomChoices.indexOf(roomActive);
    const next=event.key==='Home'?0:event.key==='End'?roomChoices.length-1:(index+(event.key==='ArrowLeft'?-1:1)+roomChoices.length)%roomChoices.length;
    roomChoices[next].click();roomChoices[next].focus();
  });
  roomPlay.addEventListener('click',()=>{roomPaused=!roomVideo.paused;if(roomVideo.paused){roomPaused=false;roomVideo.play().then(updateRoomPlay).catch(updateRoomPlay)}else{roomVideo.pause();updateRoomPlay()}});
  roomVideo.addEventListener('timeupdate',()=>{if(roomActive&&roomVideo.duration)roomActive.style.setProperty('--room-progress',`${Math.min(100,roomVideo.currentTime/roomVideo.duration*100)}%`)});
  roomVideo.addEventListener('ended',()=>{
    if(!roomManual&&roomChoices.length>1){showRoom(roomChoices[(roomChoices.indexOf(roomActive)+1)%roomChoices.length]);return}
    roomVideo.currentTime=0;playRoom();
  });
  roomVideo.addEventListener('play',updateRoomPlay);roomVideo.addEventListener('pause',updateRoomPlay);
  roomSelect?.addEventListener('change',()=>{roomManual=false;showRoom(roomChoices.find(button=>button.dataset.room===roomSelect.value)||roomChoices[0])});
  let visibilityQueued=false;
  function syncVisibility(){
    visibilityQueued=false;
    const chapterBounds=section.getBoundingClientRect();
    document.body.classList.toggle('nr-chapter-in-view',chapterBounds.top<innerHeight&&chapterBounds.bottom>0);
    const stageBounds=builder.querySelector('.stage')?.getBoundingClientRect();
    document.body.classList.toggle('nr-builder-stage-in-view',Boolean(stageBounds&&stageBounds.top<innerHeight*.9&&stageBounds.bottom>innerHeight*.1));
    const roomBounds=roomScreen.getBoundingClientRect();
    const visible=roomBounds.top<innerHeight*.8&&roomBounds.bottom>innerHeight*.2;
    if(visible!==roomVisible){roomVisible=visible;if(visible&&!document.hidden)playRoom();else roomVideo.pause()}
  }
  function scheduleVisibility(){if(visibilityQueued)return;visibilityQueued=true;requestAnimationFrame(syncVisibility)}
  addEventListener('scroll',scheduleVisibility,{passive:true});
  addEventListener('resize',scheduleVisibility);
  // The scene can appear after the initial check without a scroll or window resize.
  const stage=builder.querySelector('.stage');
  if(stage&&typeof ResizeObserver==='function')new ResizeObserver(scheduleVisibility).observe(stage);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)roomVideo.pause();else{scheduleVisibility();playRoom()}});
  function setupMoreGear(){
    const more=$('[data-more-gear]');
    if(!more)return;
    const records=[...document.querySelectorAll('[data-more-product-json]')].flatMap(node=>{
      try{const product=JSON.parse(node.textContent);return product?.handle&&product?.images?.length?[{id:node.dataset.moreProductJson,category:node.dataset.moreCategory,note:node.dataset.moreNote,product}]:[]}catch{return []}
    });
    if(!records.length){more.hidden=true;return}
    const groups=[...more.querySelectorAll('[data-more-group]')];
    const links=[...more.querySelectorAll('[data-more-item]')];
    const feature=more.querySelector('[data-more-feature]');
    const photo=more.querySelector('[data-more-image]');
    const prev=more.querySelector('[data-more-prev]');
    const next=more.querySelector('[data-more-next]');
    let group=records[0].category;
    let current=records[0];
    let frame=0;
    let photoVersion=0;
    const isLocal=location.hostname==='127.0.0.1'||location.hostname==='localhost';
    function showPhoto(){
      const images=current.product.images||[];
      frame=(frame+images.length)%Math.max(images.length,1);
      const media=images[frame];
      prev.disabled=next.disabled=images.length<2;
      more.querySelector('[data-more-count]').textContent=images.length>1?`${frame+1} / ${images.length}`:'';
      const version=++photoVersion;
      if(!media?.src){photo.removeAttribute('src');photo.alt='';return}
      photo.classList.add('is-changing');
      const preload=new Image();
      preload.onload=()=>{if(version!==photoVersion)return;photo.src=media.src;photo.alt=media.alt||current.product.title;photo.classList.remove('is-changing')};
      preload.onerror=()=>{if(version===photoVersion){photo.classList.remove('is-changing');photo.alt=current.product.title}};
      preload.src=media.src;
    }
    function showProduct(){
      feature.hidden=false;
      links.forEach(link=>{link.hidden=link.dataset.moreCategory!==group;link.dataset.active=String(link.dataset.moreItem===current.id)});
      groups.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.moreGroup===group)));
      more.querySelector('[data-more-title]').textContent=current.product.title;
      const note=more.querySelector('[data-more-note]');note.textContent=current.note||'';note.hidden=!current.note;
      const variants=current.product.variants||[];
      const prices=variants.filter(item=>item.available===true).map(item=>Number(item.price)).filter(Number.isFinite);
      const least=prices.length?Math.min(...prices):null;
      const price=more.querySelector('[data-more-price]');price.textContent=least===null?(variants.length?'Sold out':''):`${prices.some(value=>value!==least)?'From ':''}${money(least)}`;price.hidden=!variants.length;
      more.querySelector('[data-more-link]').href=current.product.url?.startsWith('https://')?current.product.url:(isLocal?'https://www.thenetreturn.com':'')+'/products/'+encodeURIComponent(current.product.handle);
      showPhoto();
      const active=more.querySelector('[data-more-item][data-active="true"]');
      const list=more.querySelector('[data-more-list]');
      if(active&&list.scrollWidth>list.clientWidth)list.scrollTo({left:active.offsetLeft-list.offsetLeft-list.clientWidth/2+active.clientWidth/2,behavior:reduced()?'instant':'smooth'});
      else if(active&&list.scrollHeight>list.clientHeight)list.scrollTo({top:active.offsetTop-list.offsetTop-list.clientHeight/2+active.clientHeight/2,behavior:reduced()?'instant':'smooth'});
    }
    groups.forEach(button=>{
      button.hidden=!records.some(record=>record.category===button.dataset.moreGroup);
      button.addEventListener('click',()=>{
        group=button.dataset.moreGroup;current=records.find(record=>record.category===group);frame=0;showProduct();
        const strip=more.querySelector('[data-more-groups]');
        strip.scrollTo({left:button.offsetLeft-strip.offsetLeft-strip.clientWidth/2+button.clientWidth/2,behavior:reduced()?'instant':'smooth'});
      });
    });
    links.forEach(link=>link.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const chosen=records.find(record=>record.id===link.dataset.moreItem);if(!chosen)return;
      event.preventDefault();group=chosen.category;current=chosen;frame=0;showProduct();
    }));
    prev.addEventListener('click',()=>{frame--;showPhoto()});
    next.addEventListener('click',()=>{frame++;showPhoto()});
    let startX=0,startY=0;
    const media=more.querySelector('.nr-more__media');
    media.addEventListener('touchstart',event=>{startX=event.changedTouches[0].screenX;startY=event.changedTouches[0].screenY},{passive:true});
    media.addEventListener('touchend',event=>{const dx=event.changedTouches[0].screenX-startX,dy=event.changedTouches[0].screenY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){frame+=dx<0?1:-1;showPhoto()}},{passive:true});
    showProduct();
  }
  setupMoreGear();
  render();showRoom(roomChoices.find(button=>button.dataset.room===roomSelect?.value)||roomChoices[0]);
  scheduleVisibility();
})();
